import ProviderTerminationService from "@app/provider-terminations/providerTerminationService";
import BulkProviderChangeReports, { VOLUME_TERMINATION_TITLE } from "@app/shared/BulkProviderChangeReports";
import { JSX, useContext } from "react";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";

const providerTerminationService = new ProviderTerminationService();
const ViewMyTerminations = (): JSX.Element => {
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
  const isZipVolumeTerminationEnabled = featureFlags.has(Features.ZIP_CODE_ANALYSIS_VOLUME_TERMINATION);
  const endpoint = () => providerTerminationService.getBulkProviderTerminationExports();
  return <BulkProviderChangeReports endpoint={endpoint} title={VOLUME_TERMINATION_TITLE} buttonTerm="Terminations" zipTerminationEnabled={isZipVolumeTerminationEnabled} />;
};

export default ViewMyTerminations;
